import { parseAiJsonReport } from "./aiJsonContract";

export const parseChatGPTResponse = (response = "", language = "Arabic") => {
  const cleanResponse = typeof response === "string" ? response.trim() : "";
  const parsed = parseAiJsonReport(cleanResponse, language);

  if (!parsed.success) {
    return {
      success: false,
      report: null,
      rawResponse: cleanResponse,
      validation: parsed.validation,
      errorMessage: parsed.errorMessage,
    };
  }

  return {
    success: true,
    report: parsed.report,
    rawResponse: cleanResponse,
    validation: parsed.validation,
    errorMessage: null,
  };
};
